import { Card } from "@/components/ui/card";

export function StatCard({ icon: Icon, label, value, accent = "emerald", testid }) {
  const colors = {
    emerald: "bg-yellow-100 dark:bg-yellow-950 text-yellow-600",
    orange: "bg-orange-50 dark:bg-orange-950 text-orange-600",
    sky: "bg-sky-50 dark:bg-sky-950 text-sky-600",
    violet: "bg-violet-50 dark:bg-violet-950 text-violet-600",
  };
  return (
    <Card className="p-5 border-slate-200/80 dark:border-slate-800" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</p>
          <p className="font-heading font-bold text-2xl mt-2">{value}</p>
        </div>
        <span className={`grid place-items-center w-11 h-11 rounded-xl ${colors[accent]}`}><Icon className="w-5 h-5" /></span>
      </div>
    </Card>
  );
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900 dark:text-white">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
